import { createSelector } from '@reduxjs/toolkit'
import { jsonApiWrapper } from '../../../jsonApiParser'
import {
  getBrandId,
  getLabels,
  getLabelSets,
  getV1LabelSets,
} from '../../getters'
import { selectCurrentBrand } from './brands'

/*
 * Selector for all Label Sets.
 */
export const selectV1LabelSets = createSelector(
  [getV1LabelSets, getBrandId],
  (v1LabelSets, brandId) => {
    if (!v1LabelSets) return null

    const workspaceLabelSetIds = Object.keys(v1LabelSets).filter(
      (id) => v1LabelSets[id].relationships.workspace.id === brandId.toString()
    )

    // Filter label sets to only include those currently present in workspace
    return workspaceLabelSetIds.reduce((acc, id) => {
      if (v1LabelSets[id]) {
        return [
          ...acc,
          jsonApiWrapper({
            data: v1LabelSets[id],
            state: window.Higgs.store.getState(),
          }),
        ]
      }
      return acc
    }, [])
  }
)

export const selectLabels = createSelector([getLabels], (labels) => labels)

export const selectLabelSets = createSelector(
  [getLabelSets],
  (labelSets) => labelSets
)

/*
 * Selector for the Primary Label Set of the Brand.
 */
export const selectPrimaryLabelSet = createSelector(
  [selectCurrentBrand],
  (brand) => {
    if (!brand) return null
    const proxiedBrand = jsonApiWrapper({
      data: brand,
      state: window.Higgs.store.getState(),
    })
    if (!proxiedBrand.primary_label_set) return null
    return proxiedBrand.primary_label_set
  }
)

export const selectPrimaryLabelSetId = createSelector(
  [selectPrimaryLabelSet],
  (labelSet) => {
    if (!labelSet) return null
    return labelSet.id
  }
)
